export default __webpack_public_path__ + "static/media/ethioder_logo.065fe2bf.jpg";